// TODO: Sync with design team
export const theme = {
  metrics: {
    indent: 8,
    spacing: 8,
    space: 8,
  },
};
